export default __webpack_public_path__ + "static/search-page-09be674b152a5d6fbd90c3bc85ba1e48.png";